import serviceRegistery from './serviceRegistery'
import Vue from 'vue'
import CONFIG from '../config/config'
import _ from 'underscore'
import store from '../store/store'
Vue.prototype.$hostname = CONFIG.developmentMode ? CONFIG.serverBaseUrl : '/'
store.state.subbrandListStore.subBrandListData

var mins = 0;
var interval = 120000;
var inProgressArray = []
var failedArray = []
var startPolling = (listData) => {
  console.log('Start polling called')
  mins = 0;
  doPolling(listData);
}

var doPolling = (listData) => {
  
  for (let i = 0; i < listData.length; i++) {
    let singleData = listData[i];
    if ( singleData.status == 1 ||
      singleData.status == 2) {
        if (inProgressArray.indexOf(singleData._id) == -1) {
          inProgressArray.push(singleData._id)
        }
    } else if (singleData.status == 3 ||
        singleData.status == 4) {
          if (failedArray.indexOf(singleData._id) == -1) {
            failedArray.push(singleData._id)
          } 
          if (inProgressArray.indexOf(singleData._id) != -1) {
            let deleteInProgressIndex = inProgressArray.indexOf(singleData._id)
            inProgressArray.splice(deleteInProgressIndex, 1)
          }

    } else {
      if (inProgressArray.indexOf(singleData._id) != -1) {
        let deleteIndex = inProgressArray.indexOf(singleData._id)
        inProgressArray.splice(deleteIndex, 1)
      }
      if (failedArray.indexOf(singleData._id) != -1) {
        let deleteFailedIndex = failedArray.indexOf(singleData._id)
        failedArray.splice(deleteFailedIndex, 1)
      }
    }
  }
 
if ($("#subbrandListTable").is(':visible')) {
    setTimeout(()=>{
      var ids;
      if( inProgressArray.length > 0 ) {
        mins = mins + 2;
        if (mins === 30) {
          ids = inProgressArray.concat(failedArray)
          mins = 0;
        } else {
          ids = inProgressArray;
        }
        apiCall(ids)
      } else if( failedArray.length > 0 ) {
        interval = 1800000;
        apiCall(failedArray)
      }

    }, interval)
  }
}

var subBrandListData = () => {
  return store.state.subbrandListStore.subBrandListData
}

var apiCall = (ids) => {
  let reqObj = {
    ids: ids
  }
  serviceRegistery
    .makeCall({
        url: Vue.prototype.$hostname + 'services/subbrand/all',
        method: 'POST',
        data: reqObj
    })
    .then(response => {
      if (response && response.data) {
          let subbrandConfigData = response.data
          store.state.subbrandListStore.subBrandListData = _.values(_.extend(_.indexBy(subBrandListData(), '_id'), _.indexBy(subbrandConfigData, '_id')))
          doPolling(response.data)
      } else {
          // errorAction()
      }
  })
}



export default {
  startPolling
}
